/* Flex Factory G-Shock studio (ff-gstudio.js). Readable source kept with the build notes. */
(function () {
"use strict";
var P = window.FF_G_PREFIX || "";
function $G(id) { return document.getElementById(P + id); }
if (!window.THREE) {
var ro = $G("readout"); if (ro) { ro.hidden = false; ro.textContent = "3D library failed to load. Refresh the page."; }
return;
}
var METAL = {
silver: { name: "Silver",    col: 0xD4D5D8, rough: 0.12 },
gold:   { name: "Gold",      col: 0xC9971F, rough: 0.19 },
rose:   { name: "Rose gold", col: 0xD28E6E, rough: 0.19 }
};
var FINISH = {
"Silver":                { base: "silver", label: "Silver",       sw: "linear-gradient(135deg,#F4F7FA,#B7C1CB 55%,#78838E)" },
"Gold":                  { base: "gold",   label: "Gold",         sw: "linear-gradient(135deg,#F5DA97,#C89320 55%,#8A6415)" },
"Rose Gold":             { base: "rose",   label: "Rose gold",    sw: "linear-gradient(135deg,#F7CDB6,#D18C6D 55%,#95533B)" },
"Silver and Gold":       { base: "silver", acc: "gold", label: "Silver, gold vine", sw: "linear-gradient(135deg,#E8EDF2 50%,#C89320 50%)" },
"White Gold and Purple": { base: "silver", stone: 0xC0247A, label: "Pink-purple", sw: "linear-gradient(135deg,#E8EDF2 50%,#C0247A 50%)" },
"White Gold and Red":    { base: "silver", stone: 0xD62A3C, label: "Red",         sw: "linear-gradient(135deg,#E8EDF2 50%,#D62A3C 50%)" },
"White Gold and Blue":   { base: "silver", stone: 0x2F72E6, label: "Blue",        sw: "linear-gradient(135deg,#E8EDF2 50%,#2F72E6 50%)" },
"White Gold and Green":  { base: "silver", stone: 0x22A85A, label: "Green",       sw: "linear-gradient(135deg,#E8EDF2 50%,#22A85A 50%)" },
"White Gold and Black":  { base: "silver", stone: 0x23262C, label: "Black",       sw: "linear-gradient(135deg,#E8EDF2 50%,#23262C 50%)" }
};
function V(id, p) { return [id, p]; }
var DESIGNS = {
flame:   { code: "CMW0024", name: "Flame",
blurb: "Flames of colour stones sweeping off the cover past the edge of the watch, with glossy red drops along them. The flame stones come in five colours; the rest is white.",
f: { "White Gold and Purple": V("67605450981619", 309), "White Gold and Red": V("67605451047155", 309), "White Gold and Blue": V("67605451014387", 309), "White Gold and Green": V("67605451079923", 309), "White Gold and Black": V("67605450948851", 309) } },
spike:   { code: "CMW0014", name: "Spikes",
blurb: "Fully iced, with polished spikes standing off every side and a second ring of spikes rising off the top.",
f: { "Silver": V("67605450621171", 318), "Gold": V("67605450653939", 318), "Rose Gold": V("67605450686707", 318) } },
thorn:   { code: "CMW0038", name: "Crown of Thorns",
blurb: "A twisted vine of stones with thorns, wrapped round the face on a fully iced cover. Choose a gold vine on silver, or all gold.",
f: { "Silver and Gold": V("67605451210995", 346), "Gold": V("67605451243763", 346) } },
rope:    { code: "CMW0040", name: "Rope",
blurb: "Thick twisted rope, iced all over: one round the face, one round the edge, and a loop round the button plate.",
f: { "Silver": V("67605451276531", 302), "Gold": V("67605451309299", 302) } },
cluster: { code: "CMW0041", name: "Cluster",
blurb: "A ring of big stones round the face, with the whole cover set edge to edge in hand-set pave, sides included.",
f: { "Silver": V("67605451342067", 371), "Gold": V("67605451374835", 371) } }
};
var COLOURS = {
white: { name: "White", band: 0xE6E7E9, plate: 0xC9CDD2, dial: "#0D0F12", ring: "#8E969F", lcd: "#20262A", ink: "#E8EDF2", sw: "#ECEDEF" },
black: { name: "Black", band: 0x17191C, plate: 0x1B1D21, dial: "#0D0F12", ring: "#8E969F", lcd: "#20262A", ink: "#E8EDF2", sw: "#17191C" },
red:   { name: "Red",   band: 0xC63A2C, plate: 0xC63A2C, dial: "#B8321F", ring: "#2A0E0B", lcd: "#B03A2A", ink: "#1A0806", sw: "#C63A2C" }
};
var MODEL_FULL = "Casio G-Shock DW-6900";
var SHOP_BASE = (typeof location !== "undefined" && /(^|\.)flexfactoryice\.com$|\.myshopify\.com$/i.test(location.hostname || "")) ? "" : "https://flexfactoryice.com";
var TERMS_VERSION = "2026-10-22";
var TERMS = [
"Each set is built to order: a new " + MODEL_FULL + " in the colour you pick, with your iced cover fitted. The watch is included in the price. Build time is 6 to 8 weeks from the day you order; shipping is on top.",
"The stones are moissanite and are sold as moissanite, never as diamond. The cover is brass, plated in the finish you choose.",
"The 3D builder shows the design. Every cover is set by hand, so stone sizes and positions vary a little from the preview and from piece to piece.",
"You see photographs of the finished watch before it ships. If something is off, it goes back.",
"Because each set is assembled to your specification it is a final sale: it cannot be returned, exchanged or refunded for a change of mind. A stone lost in the first year is reset at no charge."
];
function money(n) { return "$" + n.toLocaleString("en-US"); }
var state = { colour: "black", design: "flame", finish: "White Gold and Purple", bare: false };
function designObj() { return DESIGNS[state.design]; }
function checkoutURL() {
var D = designObj(), fv = D.f[state.finish];
if (!fv) return "";
var a = [];
function add(k, val) { if (val) a.push("attributes[" + encodeURIComponent(k) + "]=" + encodeURIComponent(val)); }
add("Watch", MODEL_FULL + ", included");
add("Watch colour", COLOURS[state.colour].name);
add("Cover design", D.name + " (" + D.code + ")");
add("Finish", (FINISH[state.finish] || {}).label || state.finish);
add("Stones", "Moissanite, hand set");
add("Build time", "6-8 weeks from the day of order");
add("Terms", "Accepted in the G-Shock studio - v" + TERMS_VERSION);
add("Built with", "3D G-Shock studio");
return SHOP_BASE + "/cart/" + fv[0] + ":1?" + a.join("&");
}
function roundedRectPts(w, h, r, cx, cy, steps) {
var p = [], s = steps || 8, x0 = -w / 2, y0 = -h / 2, i, a;
cx = cx || 0; cy = cy || 0;
function arc(ccx, ccy, a0) { for (i = 0; i <= s; i++) { a = a0 + (i / s) * Math.PI / 2; p.push([cx + ccx + Math.cos(a) * r, cy + ccy + Math.sin(a) * r]); } }
arc(x0 + w - r, y0 + r, -Math.PI / 2);
arc(x0 + w - r, y0 + h - r, 0);
arc(x0 + r, y0 + h - r, Math.PI / 2);
arc(x0 + r, y0 + r, Math.PI);
return p;
}
function norm2(v) { var l = Math.sqrt(v[0] * v[0] + v[1] * v[1]) || 1; return [v[0] / l, v[1] / l]; }
function toShape(p) { var s = new THREE.Shape(); p.forEach(function (q, i) { i ? s.lineTo(q[0], q[1]) : s.moveTo(q[0], q[1]); }); s.closePath(); return s; }
function toPath(p) { var s = new THREE.Path(); p.slice().reverse().forEach(function (q, i) { i ? s.lineTo(q[0], q[1]) : s.moveTo(q[0], q[1]); }); s.closePath(); return s; }
function walk(p, step) {
var out = [], i, L = 0, segs = [];
for (i = 0; i < p.length; i++) { var a = p[i], b = p[(i + 1) % p.length], l = Math.hypot(b[0] - a[0], b[1] - a[1]); segs.push([a, b, l]); L += l; }
var n = Math.max(8, Math.round(L / step)), d = L / n, acc = 0, s = 0, used = 0;
for (i = 0; i < n; i++) {
var target = i * d;
while (s < segs.length - 1 && used + segs[s][2] < target) { used += segs[s][2]; s++; }
var g = segs[s], t = g[2] ? (target - used) / g[2] : 0;
var x = g[0][0] + (g[1][0] - g[0][0]) * t, y = g[0][1] + (g[1][1] - g[0][1]) * t;
var tx = (g[1][0] - g[0][0]) / (g[2] || 1), ty = (g[1][1] - g[0][1]) / (g[2] || 1);
out.push({ x: x, y: y, nx: ty, ny: -tx });
}
return out;
}
function seeded(s) { return function () { s = (s * 9301 + 49297) % 233280; return s / 233280; }; }
function sdCircle(x, y, cx, cy, r) { return Math.hypot(x - cx, y - cy) - r; }
function sdEll(x, y, cx, cy, rx, ry) { return (Math.hypot((x - cx) / rx, (y - cy) / ry) - 1) * Math.min(rx, ry); }
function sdBox(x, y, cx, cy, hw, hh, r) {
var qx = Math.abs(x - cx) - hw + r, qy = Math.abs(y - cy) - hh + r;
return Math.hypot(Math.max(qx, 0), Math.max(qy, 0)) + Math.min(Math.max(qx, qy), 0) - r;
}
function smin(a, b, k) { var h = Math.max(k - Math.abs(a - b), 0) / k; return Math.min(a, b) - h * h * k * 0.25; }
function sminAll(list, k) { var d = list[0]; for (var i = 1; i < list.length; i++) d = smin(d, list[i], k); return d; }
function trace(sd, cx, cy, n, rmax) {
var p = [], i, k;
for (i = 0; i < n; i++) {
var a = (i / n) * Math.PI * 2, c = Math.cos(a), s = Math.sin(a), lo = 0, hi = rmax;
for (k = 0; k < 26; k++) { var m = (lo + hi) / 2; if (sd(cx + c * m, cy + s * m) < 0) lo = m; else hi = m; }
p.push([cx + c * lo, cy + s * lo]);
}
return p;
}
function edgeX(sd, y, side) { var lo = 0, hi = 40; for (var k = 0; k < 26; k++) { var m = (lo + hi) / 2; if (sd(side * m, y) < 0) lo = m; else hi = m; } return lo; }
/* The cover outline traced from the owner's straight-on photo (mm, right half from the top down):
   a flat top tab with soft corners, shoulders curving out to one long guard over both buttons on each
   side, then curving back in to a flat bottom tab. Mirrored, smoothed, and kept as a polar table so the
   distance lookups stay fast. */
var OUTLINE_R = [[0, 28.4], [10, 28.4], [13.6, 28.1], [14.4, 27.3], [14.7, 25.5], [15.1, 21.3], [17.7, 18.9], [18.5, 17.7], [19.9, 14.9], [21.1, 11.7], [22.5, 8.5], [25.7, 6.9], [26.7, 3.7], [26.8, -2.6], [25.9, -7.4], [23.7, -10.6], [21.7, -13.8], [19.3, -17.0], [16.5, -20.2], [15.5, -22.5], [15.1, -26.5], [14.4, -28.0], [13.0, -28.5], [0, -28.5]];
var _outSD = null;
function outlineSD() {
if (_outSD) return _outSD;
var half = OUTLINE_R, ring = [], i, k;
for (i = 0; i < half.length; i++) ring.push([half[i][0], half[i][1]]);
for (i = half.length - 2; i > 0; i--) ring.push([-half[i][0], half[i][1]]);
var poly = [], n = ring.length;
for (i = 0; i < n; i++) {
var p0 = ring[(i - 1 + n) % n], p1 = ring[i], p2 = ring[(i + 1) % n], p3 = ring[(i + 2) % n];
for (k = 0; k < 8; k++) {
var t = k / 8, t2 = t * t, t3 = t2 * t;
poly.push([0.5 * (2 * p1[0] + (-p0[0] + p2[0]) * t + (2 * p0[0] - 5 * p1[0] + 4 * p2[0] - p3[0]) * t2 + (-p0[0] + 3 * p1[0] - 3 * p2[0] + p3[0]) * t3),
0.5 * (2 * p1[1] + (-p0[1] + p2[1]) * t + (2 * p0[1] - 5 * p1[1] + 4 * p2[1] - p3[1]) * t2 + (-p0[1] + 3 * p1[1] - 3 * p2[1] + p3[1]) * t3)]);
}
}
var NA = 1440, RT = new Float32Array(NA + 1), m = poly.length;
for (var j = 0; j <= NA; j++) {
var ang = j / NA * Math.PI * 2, c = Math.cos(ang), sn = Math.sin(ang), best = 0;
for (i = 0, k = m - 1; i < m; k = i++) {
var ax = poly[k][0], ay = poly[k][1], bx = poly[i][0], by = poly[i][1], ex = bx - ax, ey = by - ay;
var den = c * ey - sn * ex; if (Math.abs(den) < 1e-9) continue;
var tr = (ax * ey - ay * ex) / den, u = (ax * sn - ay * c) / den;
if (u >= 0 && u <= 1 && tr > best) best = tr;
}
RT[j] = best;
}
_outSD = function (x, y) {
var rho = Math.hypot(x, y), a = Math.atan2(y, x); if (a < 0) a += Math.PI * 2;
var f = a / (Math.PI * 2) * NA, i0 = Math.floor(f) % NA, u = f - Math.floor(f), r = RT[i0] * (1 - u) + RT[i0 + 1] * u;
var dr = (RT[i0 + 1] - RT[i0]) * NA / (Math.PI * 2);
return (rho - r) / Math.sqrt(1 + (dr / r) * (dr / r));
};
return _outSD;
}
function modelGeo(design) {
var g = { windows: [], buttons: [] };
g.sdOut = outlineSD();
/* the face: round across the top, flat along the bottom where the display sits */
g.ap = [0, -2.4];
g.sdAp = function (x, y) { var a = sdCircle(x, y, 0, -2.4, 16.9), b = -(y + 12.8); var h = Math.max(3 - Math.abs(a - b), 0) / 3; return Math.max(a, b) + h * h * 0.75; };
var wy = design === "rope" ? -21.8 : -21.3, wh = design === "rope" ? 2.5 : 2.7;
g.windows = [{ c: [0, wy], sd: function (x, y) { return sdBox(x, y, 0, wy, 7.0, wh, 1.3); }, plate: true }];
g.buttons = [[1, 3.8], [-1, 3.8], [1, -6.4], [-1, -6.4]];
g.face = "dw"; g.lugY = 22.5; g.strapW = [24, 21]; g.wrist = 31; g.ring = 5.0;
if (design === "rope" || design === "cluster") g.bulge = 1.5;
g.outline = trace(g.sdOut, 0, 0, 260, 40);
g.aperture = trace(g.sdAp, g.ap[0], g.ap[1], 200, 30);
g.apertureFace = trace(function (x, y) { return g.sdAp(x, y) - 0.4; }, g.ap[0], g.ap[1], 160, 30);
g.caseOutline = trace(function (x, y) { return g.sdOut(x, y) + 1.4; }, 0, 0, 200, 40);
g.windows.forEach(function (w) { w.poly = trace(w.sd, w.c[0], w.c[1], 48, 12); });
return g;
}
function faceTexture(C) {
var N = 1024, c = document.createElement("canvas"); c.width = c.height = N;
var x = c.getContext("2d"), cx = N / 2, cy = N / 2 + 94;
var red = C === COLOURS.red;
x.fillStyle = C.dial; x.fillRect(0, 0, N, N);
var g = x.createRadialGradient(cx - 160, cy - 220, 40, cx, cy, N * 0.72);
g.addColorStop(0, "rgba(255,255,255," + (red ? 0.12 : 0.06) + ")"); g.addColorStop(1, "rgba(0,0,0," + (red ? 0.28 : 0.4) + ")");
x.fillStyle = g; x.fillRect(0, 0, N, N);
x.fillStyle = red ? "#2A0E0B" : "#C9CFD6"; x.textAlign = "center"; x.textBaseline = "middle";
function arcText(txt, a0, r, size, inward) {
x.save(); x.font = "700 " + size + "px 'Barlow','Arial Narrow',Arial,sans-serif";
var w = x.measureText(txt).width, ang = w / r, a = a0 - (inward ? -1 : 1) * ang / 2;
for (var i = 0; i < txt.length; i++) {
var cw = x.measureText(txt[i]).width, da = cw / r;
a += (inward ? -1 : 1) * da / 2;
x.save(); x.translate(cx + Math.cos(a) * r, cy + Math.sin(a) * r); x.rotate(a + (inward ? -Math.PI / 2 : Math.PI / 2)); x.fillText(txt[i], 0, 0); x.restore();
a += (inward ? -1 : 1) * da / 2;
}
x.restore();
}
arcText("ILLUMINATOR", -Math.PI / 2, 440, 30, false);
arcText("ALARM CHRONO", -Math.PI / 4.2, 440, 30, false);
arcText("TIMER RESET", -Math.PI + Math.PI / 4.2, 440, 30, false);
arcText("LIGHT/ALARM", Math.PI / 9, 440, 26, true);
arcText("LIGHT", Math.PI - Math.PI / 9, 440, 26, true);
x.font = "700 40px 'Barlow',Arial,sans-serif"; x.fillStyle = red ? "#1E0A08" : "#E6EAEE";
x.fillText("SHOCK RESIST", cx, cy - 330);
function eye(ex, ey, r, big) {
x.fillStyle = red ? "#5A140E" : "#15181C"; x.beginPath(); x.arc(ex, ey, r, 0, Math.PI * 2); x.fill();
x.strokeStyle = red ? "#2A0A07" : "#4A525C"; x.lineWidth = big ? 10 : 8; x.stroke();
var ig = x.createRadialGradient(ex - r * 0.3, ey - r * 0.4, 4, ex, ey, r);
ig.addColorStop(0, "rgba(255,255,255,.10)"); ig.addColorStop(1, "rgba(0,0,0,.35)"); x.fillStyle = ig; x.fill();
x.strokeStyle = red ? "#8A2A20" : "#59626C"; x.lineWidth = 3;
for (var k = 0; k < 12; k++) { var a = k / 12 * Math.PI * 2; x.beginPath(); x.moveTo(ex + Math.cos(a) * r * 0.66, ey + Math.sin(a) * r * 0.66); x.lineTo(ex + Math.cos(a) * r * 0.86, ey + Math.sin(a) * r * 0.86); x.stroke(); }
x.strokeStyle = red ? "#1A0806" : "#AEB6BF"; x.lineWidth = big ? 7 : 5; x.beginPath(); x.moveTo(ex, ey); x.lineTo(ex + r * 0.42, ey - r * 0.5); x.stroke();
}
eye(cx - 215, cy - 175, 88); eye(cx - 25, cy - 175, 88); eye(cx + 190, cy - 170, 112, true);
var lx = cx - 300, ly = cy - 30, lw = 600, lh = 250;
x.fillStyle = red ? "#8F2F22" : "#121518";
x.beginPath(); x.moveTo(lx + 30, ly); x.lineTo(lx + lw - 30, ly); x.quadraticCurveTo(lx + lw, ly, lx + lw, ly + 30);
x.lineTo(lx + lw, ly + lh); x.lineTo(lx, ly + lh); x.lineTo(lx, ly + 30); x.quadraticCurveTo(lx, ly, lx + 30, ly); x.fill();
x.strokeStyle = red ? "#5A160F" : "#2E343B"; x.lineWidth = 8; x.stroke();
x.fillStyle = red ? "#2A0A07" : "#3A434B"; x.font = "700 64px 'JetBrains Mono',ui-monospace,monospace";
x.fillText("TH  3-18", cx + 20, ly + 62);
x.font = "700 130px 'JetBrains Mono',ui-monospace,monospace"; x.fillText("22:44", cx - 30, ly + 170);
x.font = "700 70px 'JetBrains Mono',ui-monospace,monospace"; x.fillText("13", cx + 230, ly + 186);
x.font = "700 30px 'Barlow',Arial,sans-serif"; x.fillStyle = red ? "#1E0A08" : "#C9CFD6";
x.fillText("WATER 20BAR RESIST", cx, cy + 268);
var tex = new THREE.CanvasTexture(c); tex.anisotropy = 4; tex.encoding = THREE.sRGBEncoding;
return tex;
}
var cvs = $G("gl");
var renderer, scene, camera, root, keyLight, rimLight;
var metalMat, accMat, stoneMat, resinMat, darkMat, buckleMat, glassMat, windowMat, clawMat, plateMat, plateInk;
var cam = { az: 0, el: 0.34, dist: 200, tAz: 0, tEl: 0.34, tDist: 150 };
var spin = true, dragging = false, lastX = 0, lastY = 0, userZoomed = false, swayT = 0;
var clock = { t: 0, last: 0, w: 0 };
var anim = { stones: [], setStart: 0, setDur: 1.35, settling: false, flashes: [], metalTo: null, introDone: false };
function studioEnv(r) {
var c = document.createElement("canvas"); c.width = 1024; c.height = 512;
var x = c.getContext("2d");
var g = x.createLinearGradient(0, 0, 0, 512);
g.addColorStop(0, "#3A3A3C"); g.addColorStop(0.42, "#1A1A1C"); g.addColorStop(0.55, "#121213"); g.addColorStop(1, "#050505");
x.fillStyle = g; x.fillRect(0, 0, 1024, 512);
var ob = x.createLinearGradient(0, 0, 0, 120); ob.addColorStop(0, "rgba(255,255,255,.95)"); ob.addColorStop(1, "rgba(255,255,255,0)");
x.fillStyle = ob; x.fillRect(0, 0, 1024, 120);
[[40, 0.95], [190, 0.55], [330, 0.9], [470, 0.4], [600, 1.0], [745, 0.6], [880, 0.85]].forEach(function (st) {
var w = 46, lg = x.createLinearGradient(st[0], 0, st[0] + w, 0);
lg.addColorStop(0, "rgba(255,255,255,0)"); lg.addColorStop(0.25, "rgba(255,255,255," + st[1] + ")"); lg.addColorStop(0.75, "rgba(255,255,255," + st[1] + ")"); lg.addColorStop(1, "rgba(255,255,255,0)");
x.fillStyle = lg; x.fillRect(st[0], 120, w, 200);
});
[[150, 86, 74, 1.0], [620, 70, 56, 0.85], [400, 150, 30, 0.45], [880, 120, 40, 0.5]].forEach(function (s) {
var rg = x.createRadialGradient(s[0] + s[2] / 2, s[1] + s[3] / 2, 2, s[0] + s[2] / 2, s[1] + s[3] / 2, s[2]);
rg.addColorStop(0, "rgba(255,255,255," + s[3] + ")"); rg.addColorStop(1, "rgba(255,255,255,0)");
x.fillStyle = rg; x.fillRect(s[0] - s[2], s[1] - s[2], s[2] * 3, s[2] * 3);
});
var seed = 7, k;
function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
for (k = 0; k < 260; k++) {
var sx = rnd() * 1024, sy = 10 + rnd() * 470, sr = 2 + rnd() * 4.5, sa = 0.7 + rnd() * 0.3;
var pg = x.createRadialGradient(sx, sy, 0, sx, sy, sr);
pg.addColorStop(0, "rgba(255,255,255," + sa + ")"); pg.addColorStop(0.45, "rgba(255,255,255," + (sa * 0.5) + ")"); pg.addColorStop(1, "rgba(255,255,255,0)");
x.fillStyle = pg; x.fillRect(sx - sr, sy - sr, sr * 2, sr * 2);
}
var tex = new THREE.CanvasTexture(c); tex.mapping = THREE.EquirectangularReflectionMapping;
var p = new THREE.PMREMGenerator(r); p.compileEquirectangularShader();
var t = p.fromEquirectangular(tex).texture; p.dispose(); tex.dispose();
return t;
}
function init() {
renderer = new THREE.WebGLRenderer({ canvas: cvs, antialias: true, alpha: true });
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.05;
scene = new THREE.Scene();
camera = new THREE.PerspectiveCamera(30, 1, 1, 1200);
scene.environment = studioEnv(renderer);
scene.add(new THREE.AmbientLight(0xffffff, 0.16));
keyLight = new THREE.DirectionalLight(0xffffff, 1.9); keyLight.position.set(26, 42, 58); scene.add(keyLight);
rimLight = new THREE.DirectionalLight(0xFFFFFF, 0.7); rimLight.position.set(-44, 14, -36); scene.add(rimLight);
var fill = new THREE.DirectionalLight(0xFFE7BF, 0.45); fill.position.set(-20, -34, 30); scene.add(fill);
metalMat = new THREE.MeshStandardMaterial({ color: METAL.silver.col, metalness: 1.0, roughness: 0.14, envMapIntensity: 1.5 });
accMat = new THREE.MeshStandardMaterial({ color: METAL.gold.col, metalness: 1.0, roughness: 0.19, envMapIntensity: 1.5 });
buckleMat = new THREE.MeshStandardMaterial({ color: 0xB9C2CC, metalness: 1.0, roughness: 0.25, envMapIntensity: 1.2 });
stoneMat = new THREE.MeshStandardMaterial({ color: 0xFFFFFF, metalness: 0.96, roughness: 0.0, envMapIntensity: 3.4, flatShading: true });
resinMat = new THREE.MeshStandardMaterial({ color: new THREE.Color(COLOURS.black.band).convertSRGBToLinear(), metalness: 0.0, roughness: 0.5, envMapIntensity: 0.32 });
darkMat = new THREE.MeshStandardMaterial({ color: new THREE.Color(0x07080A).convertSRGBToLinear(), metalness: 0.0, roughness: 0.8, envMapIntensity: 0.2 });
glassMat = new THREE.MeshPhysicalMaterial({ color: 0xffffff, metalness: 0, roughness: 0.03, transparent: true, opacity: 0.05, envMapIntensity: 1.0, depthWrite: false });
windowMat = new THREE.MeshStandardMaterial({ color: 0x050506, metalness: 0, roughness: 0.6, envMapIntensity: 0.2 });
clawMat = new THREE.MeshPhysicalMaterial({ color: new THREE.Color(0xC4121E).convertSRGBToLinear(), metalness: 0.1, roughness: 0.18, clearcoat: 1, clearcoatRoughness: 0.05, envMapIntensity: 1.3 });
plateMat = new THREE.MeshPhysicalMaterial({ color: 0x1B1D21, metalness: 0.25, roughness: 0.3, clearcoat: 0.6, envMapIntensity: 0.9 });
plateInk = new THREE.MeshStandardMaterial({ color: 0xB8C0C8, metalness: 0.8, roughness: 0.3, envMapIntensity: 1.0 });
root = new THREE.Group(); scene.add(root);
resize(); window.addEventListener("resize", resize);
}
var sizeW = -1, sizeH = -1;
function resize() {
var w = cvs.clientWidth, h = cvs.clientHeight;
if (!w || !h) return false;
if (w === sizeW && h === sizeH) return true;
sizeW = w; sizeH = h;
renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
renderer.setSize(w, h, false);
camera.aspect = w / h; camera.updateProjectionMatrix();
if (!userZoomed) frameCamera();
return true;
}
var faceMesh = null;
function clearRoot() {
_sph = null;
for (var i = root.children.length - 1; i >= 0; i--) {
var o = root.children[i];
o.traverse(function (c) { if (c.geometry) c.geometry.dispose(); if (c.material && c.userData.ownsMat) { if (c.material.map) c.material.map.dispose(); c.material.dispose(); } });
root.remove(o);
}
faceMesh = null;
anim.stones = []; anim.flashes = [];
root.position.set(0, 0, 0); root.rotation.set(0, 0, 0); root.updateMatrixWorld(true);
}
var _m = new THREE.Matrix4(), _q = new THREE.Quaternion(), _p = new THREE.Vector3(), _sc = new THREE.Vector3(),
_wp = new THREE.Vector3(), _wq = new THREE.Quaternion(), _ws = new THREE.Vector3(), _n = new THREE.Vector3(),
_c = new THREE.Color(), _flash = new THREE.Color(), _z = new THREE.Vector3(0, 0, 1), _y = new THREE.Vector3(0, 1, 0);
function stoneAt(list, x, y, z, nx, ny, nz, r, col) {
var crown = r * 0.62;
_n.set(nx, ny, nz).normalize();
_p.set(x, y, z).addScaledVector(_n, crown * 0.40 - 0.03);
_jit.set(_n.x + (Math.random() - 0.5) * 0.22, _n.y + (Math.random() - 0.5) * 0.22, _n.z + (Math.random() - 0.5) * 0.22).normalize();
_q.setFromUnitVectors(_y, _jit);
_q2s.setFromAxisAngle(_jit, Math.random() * Math.PI); _q.premultiply(_q2s);
_sc.set(r, crown, r);
_m.compose(_p, _q, _sc);
list.push({ m: _m.clone(), col: col == null ? 0xFFFFFF : col });
}
var _jit = new THREE.Vector3(), _q2s = new THREE.Quaternion();
var _stoneGeo = null;
function stoneGeo() {
if (_stoneGeo) return _stoneGeo;
var pts = [new THREE.Vector2(0, -0.62), new THREE.Vector2(1.0, 0.02), new THREE.Vector2(1.0, 0.1), new THREE.Vector2(0.82, 0.3), new THREE.Vector2(0.54, 0.46), new THREE.Vector2(0, 0.46)];
_stoneGeo = new THREE.LatheGeometry(pts, 12);
return _stoneGeo;
}
function makeInstanced(geo, list) {
var mesh = new THREE.InstancedMesh(geo, stoneMat, list.length);
var rec = { mesh: mesh, pos: [], quat: [], scl: [], delay: [], base: [] };
var minY = Infinity, maxY = -Infinity, i;
for (i = 0; i < list.length; i++) {
list[i].m.decompose(_wp, _wq, _ws);
rec.pos.push(_wp.clone()); rec.quat.push(_wq.clone()); rec.scl.push(_ws.clone());
var bc = new THREE.Color(list[i].col); rec.base.push(bc);
if (_wp.y < minY) minY = _wp.y; if (_wp.y > maxY) maxY = _wp.y;
mesh.setColorAt(i, bc);
}
var span = Math.max(1, maxY - minY);
for (i = 0; i < list.length; i++) {
rec.delay.push(Math.abs(rec.pos[i].y) / (span / 2) * 0.78 + Math.random() * 0.17);
_m.compose(rec.pos[i], rec.quat[i], _sc.set(0.0001, 0.0001, 0.0001));
mesh.setMatrixAt(i, _m);
}
mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
if (mesh.instanceColor) { mesh.instanceColor.setUsage(THREE.DynamicDrawUsage); mesh.instanceColor.needsUpdate = true; }
mesh.instanceMatrix.needsUpdate = true;
return rec;
}
function add(mesh, mat, watch) { var m = new THREE.Mesh(mesh, mat); if (watch) m.userData.isWatch = true; root.add(m); return m; }
var TOP = 0, COVER_H = 10.5, SLOPE = 1.5, STEP = 0.75, BEV = 0;
var EDGE_D = 1.9, EDGE_W = 2.8, BULGE = 1.1;
function bgv(G) { return G && G.bulge != null ? G.bulge : BULGE; }
function bulge(t, G) { return bgv(G) * Math.sin(Math.PI * Math.max(0, Math.min(1, t))); }
function bulgeD(t, G) { return bgv(G) * Math.PI * Math.cos(Math.PI * Math.max(0, Math.min(1, t))); }
var FACE_Z = TOP - SLOPE - 2.0, CASE_TOP = FACE_Z - 0.25, CASE_BOT = TOP - 15.5, STRAP_Z = TOP - 12.2;
function sm(a, b, x) { var t = Math.max(0, Math.min(1, (x - a) / (b - a))); return t * t * (3 - 2 * t); }
function prof(G, x, y) {
var d1 = Math.max(0, G.sdAp(x, y)), d2 = Math.max(0, -G.sdOut(x, y)), z = TOP;
z -= SLOPE * Math.pow(1 - sm(0, 1.9, d1), 2);
if (G.convex) z -= G.convex * Math.pow(d1 / (d1 + d2 + 1e-6), 1.6);
if (G.ring) z -= STEP * sm(G.ring - 0.45, G.ring + 0.75, d1);
var ed = G.edgeD != null ? G.edgeD : EDGE_D, ew = G.edgeW != null ? G.edgeW : EDGE_W;
z -= G.chamfer ? ed * Math.max(0, 1 - d2 / ew) : ed * Math.pow(1 - sm(0, ew, d2), 2);
return z + (G.lift ? G.lift(x, y) : 0);
}
function topZ(G, x, y) { return prof(G, x, y); }
function topN(G, x, y) {
var e = 0.25, dx = (prof(G, x + e, y) - prof(G, x - e, y)) / (2 * e), dy = (prof(G, x, y + e) - prof(G, x, y - e)) / (2 * e);
return new THREE.Vector3(-dx, -dy, 1).normalize();
}
function rayHit(sd, cx, cy, c, s, rmax) {
var lo = 0, hi = rmax;
for (var k = 0; k < 24; k++) { var m = (lo + hi) / 2; if (sd(cx + c * m, cy + s * m) < 0) lo = m; else hi = m; }
return lo;
}
function coverGeo(G, top, h) {
var NA = 300, NU = 30, cx = G.ap[0], cy = G.ap[1], i, j, rings = [];
var zBot = top - h, rIn = [], rOut = [], dirs = [];
for (i = 0; i < NA; i++) {
var a = (i / NA) * Math.PI * 2, c = Math.cos(a), s = Math.sin(a);
dirs.push([c, s]); rIn.push(rayHit(G.sdAp, cx, cy, c, s, 30)); rOut.push(rayHit(G.sdOut, cx, cy, c, s, 45));
}
function ring(u, zf) {
var r = [];
for (i = 0; i < NA; i++) {
var R = rIn[i] + (rOut[i] - rIn[i]) * u, x = cx + dirs[i][0] * R, y = cy + dirs[i][1] * R;
r.push([x, y, zf == null ? prof(G, x, y) + (top - TOP) : zf]);
}
return r;
}
rings.push(ring(0, zBot));
rings.push(ring(0, top - SLOPE - 0.7));
for (j = 0; j <= NU; j++) { var u = j / NU; rings.push(ring(0.5 - 0.5 * Math.cos(Math.PI * u))); }
var edgeZ = ring(1).map(function (q) { return q[2]; });
[0.1, 0.22, 0.36, 0.5, 0.64, 0.78, 0.9, 1].forEach(function (t) {
var r = [];
for (i = 0; i < NA; i++) {
var R = rOut[i] + bulge(t, G);
r.push([cx + dirs[i][0] * R, cy + dirs[i][1] * R, edgeZ[i] - t * (edgeZ[i] - zBot)]);
}
rings.push(r);
});
var pos = [], idx = [];
rings.forEach(function (r) { r.forEach(function (p) { pos.push(p[0], p[1], p[2]); }); });
for (j = 0; j < rings.length - 1; j++) for (i = 0; i < NA; i++) {
var a0 = j * NA + i, a1 = j * NA + (i + 1) % NA, b0 = a0 + NA, b1 = a1 + NA;
idx.push(a0, b0, a1, a1, b0, b1);
}
var L = rings.length - 1;
for (i = 0; i < NA; i++) { var o0 = L * NA + i, o1 = L * NA + (i + 1) % NA, n0 = i, n1 = (i + 1) % NA; idx.push(o0, n0, o1, o1, n0, n1); }
var geo = new THREE.BufferGeometry();
geo.setAttribute("position", new THREE.Float32BufferAttribute(pos, 3));
geo.setIndex(idx); geo.computeVertexNormals();
return geo;
}
function bezelGeo(G, outline, h, top, slope, solid) {
var cs = toShape(outline), bt = 0.8;
var geo = new THREE.ExtrudeGeometry(cs, { depth: h - 2 * bt, bevelEnabled: true, bevelThickness: bt, bevelSize: 0.8, bevelSegments: 3, steps: 1 });
geo.computeBoundingBox();
geo.translate(0, 0, top - geo.boundingBox.max.z);
return geo;
}
function faceGeo(poly) {
var minx = 1e9, maxx = -1e9, miny = 1e9, maxy = -1e9;
poly.forEach(function (p) { minx = Math.min(minx, p[0]); maxx = Math.max(maxx, p[0]); miny = Math.min(miny, p[1]); maxy = Math.max(maxy, p[1]); });
var cx = (minx + maxx) / 2, cy = (miny + maxy) / 2, S = Math.max(maxx - minx, maxy - miny) * 1.04;
var geo = new THREE.ShapeGeometry(toShape(poly)), pa = geo.attributes.position, uv = geo.attributes.uv;
for (var i = 0; i < pa.count; i++) uv.setXY(i, (pa.getX(i) - cx) / S + 0.5, (pa.getY(i) - cy) / S + 0.5);
uv.needsUpdate = true;
return geo;
}
function strapGeo(curve, n, wFn, tFn) {
var K = 20, pos = [], idx = [], i, k;
for (i = 0; i <= n; i++) {
var s = i / n, P = curve.getPointAt(s), T = curve.getTangentAt(s);
var Ny = -T.z, Nz = T.y, l = Math.hypot(Ny, Nz) || 1; Ny /= l; Nz /= l;
var w = wFn(s) / 2, t = tFn(s) / 2;
for (k = 0; k < K; k++) {
var a = (k / K) * Math.PI * 2, c = Math.cos(a), sn = Math.sin(a);
var ox = (c < 0 ? -1 : 1) * Math.pow(Math.abs(c), 0.22) * w, on = (sn < 0 ? -1 : 1) * Math.pow(Math.abs(sn), 0.55) * t;
pos.push(P.x + ox, P.y + Ny * on, P.z + Nz * on);
}
}
for (i = 0; i < n; i++) for (k = 0; k < K; k++) {
var a0 = i * K + k, a1 = i * K + (k + 1) % K, b0 = a0 + K, b1 = a1 + K;
idx.push(a0, b0, a1, a1, b0, b1);
}
var geo = new THREE.BufferGeometry();
geo.setAttribute("position", new THREE.Float32BufferAttribute(pos, 3));
geo.setIndex(idx); geo.computeVertexNormals();
return geo;
}
function frameAt(curve, s) {
var P = curve.getPointAt(s), T = curve.getTangentAt(s), N = new THREE.Vector3(0, -T.z, T.y).normalize();
return { P: P, T: T, N: N, X: new THREE.Vector3(1, 0, 0) };
}
function sAtY(curve, y, from, to) {
var best = from, bd = 1e9;
for (var i = 0; i <= 200; i++) { var s = from + (to - from) * i / 200, d = Math.abs(curve.getPointAt(s).y - y); if (d < bd) { bd = d; best = s; } }
return best;
}
function buildStrap(G, stones, iceBuckle) {
var L = G.lugY, ay = G.wrist, z = G.strapZ != null ? G.strapZ : STRAP_Z, ST = 3.3, wl = G.strapW[0], wb = G.strapW[1];
function V3(y, zz) { return new THREE.Vector3(0, y, zz); }
var upPts = [V3(L - 4, z), V3(L + 1.5, z - 0.4), V3(L + 5.5, z - 4), V3(ay, z - 13), V3(ay + 0.4, z - 25), V3(ay - 3, z - 37), V3(ay * 0.6, z - 46.5), V3(5, z - 50.2)];
var up = new THREE.CatmullRomCurve3(upPts, false, "centripetal");
var wFn = function (s) { var k = Math.min(1, s / 0.45); k = k * k * (3 - 2 * k); return wl + (wb - wl) * k; };
var tFn = function (s) { return ST + (1 - Math.min(1, s / 0.2)) * 0.7; };
var upMesh = new THREE.Mesh(strapGeo(up, 140, wFn, tFn), resinMat); upMesh.userData.isWatch = true; root.add(upMesh);
var dnPts = upPts.slice(0, 7).map(function (p) { return V3(-p.y, p.z); });
dnPts.push(V3(-5, z - 50.6), V3(0, z - 52.8));
var sA = sAtY(up, 3, 0.85, 1), sB = sAtY(up, ay * 0.82, 0.55, 0.9);
for (var i = 0; i <= 6; i++) {
var s = sA + (sB - sA) * (i / 6), f = frameAt(up, s);
dnPts.push(f.P.clone().addScaledVector(f.N, ST + 0.35));
}
var dn = new THREE.CatmullRomCurve3(dnPts, false, "centripetal");
var dnW = function (s) { var e = Math.max(0, (s - 0.95) / 0.05); return wFn(Math.min(s, 0.8)) * (1 - 0.55 * e * e); };
var dnT = function (s) { var e = Math.max(0, (s - 0.96) / 0.04); return tFn(s) * (1 - 0.4 * e); };
var dnMesh = new THREE.Mesh(strapGeo(dn, 170, dnW, dnT), resinMat); dnMesh.userData.isWatch = true; root.add(dnMesh);
if (!G.pinTuck) {
var rb = new THREE.Matrix4();
[[up, wFn, tFn, 1], [dn, dnW, dnT, -1]].forEach(function (c) {
[0.075, 0.105, 0.135].forEach(function (s0) {
var rf = frameAt(c[0], s0), rg = new THREE.BoxGeometry(c[1](s0) - 3, 0.9, 0.7);
var rm = new THREE.Mesh(rg, resinMat); rb.makeBasis(rf.X, rf.T, rf.N); rm.quaternion.setFromRotationMatrix(rb);
rm.position.copy(rf.P).addScaledVector(rf.N, c[3] * (c[2](s0) / 2 + 0.05)); rm.userData.isWatch = true; root.add(rm);
});
});
}
var len = dn.getLength(), holeGeo = new THREE.CylinderGeometry(0.85, 0.85, ST + 0.5, 12);
for (var j = 0; j < 8; j++) {
var hs = 1 - (9 + j * 6.4) / len, hf = frameAt(dn, hs), hole = new THREE.Mesh(holeGeo, darkMat);
hole.position.copy(hf.P); hole.quaternion.setFromUnitVectors(_y, hf.N); root.add(hole);
}
var bf = frameAt(up, 1), basis = new THREE.Matrix4();
{
var bw = wb + 3.6, bh = 12;
var bShape = toShape(roundedRectPts(bw, bh, 2.4, 0, 0, 4)); bShape.holes.push(toPath(roundedRectPts(wb + 0.8, bh - 4.4, 1.2, 0, 0, 3)));
var bGeo = new THREE.ExtrudeGeometry(bShape, { depth: 1.6, bevelEnabled: true, bevelThickness: 0.35, bevelSize: 0.35, bevelSegments: 2 });
bGeo.translate(0, 0, -0.8);
var bm = new THREE.Mesh(bGeo, iceBuckle ? metalMat : buckleMat); bm.userData.isWatch = true;
basis.makeBasis(bf.X, bf.T, bf.N);
bm.quaternion.setFromRotationMatrix(basis);
bm.position.copy(bf.P).addScaledVector(bf.T, bh / 2 - 1.5).addScaledVector(bf.N, ST * 0.9);
root.add(bm);
var tongue = new THREE.Mesh(new THREE.BoxGeometry(1.2, bh - 2.2, 0.9), buckleMat);
tongue.quaternion.copy(bm.quaternion); tongue.position.copy(bm.position).addScaledVector(bf.N, 1.3); root.add(tongue);
}
var ks = sAtY(up, 13, 0.75, 1), kf = frameAt(up, ks);
var kShape = toShape(roundedRectPts(wb + 2.6, ST * 2 + 2.6, 1.6, 0, 0, 3));
kShape.holes.push(toPath(roundedRectPts(wb + 0.6, ST * 2 + 0.7, 0.8, 0, 0, 3)));
var kGeo = new THREE.ExtrudeGeometry(kShape, { depth: 4.4, bevelEnabled: true, bevelThickness: 0.3, bevelSize: 0.3, bevelSegments: 2 });
kGeo.translate(0, 0, -2.2);
var km = new THREE.Mesh(kGeo, resinMat); km.userData.isWatch = true;
basis.makeBasis(kf.X, kf.N, kf.T.clone().negate());
km.quaternion.setFromRotationMatrix(basis);
km.position.copy(kf.P).addScaledVector(kf.N, ST / 2 + 0.2);
root.add(km);
}
var _sph = null;
function SPH() { return _sph || (_sph = new THREE.SphereGeometry(1, 18, 12)); }
function paveRows(G, r, keep, big) {
var p = r * 2 * 0.99, cell = Math.max(p, big ? big[0][0] * 2 : 0), grid = {}, out = [];
function free(x, y, rr) {
var gx = Math.floor(x / cell), gy = Math.floor(y / cell);
for (var i = -1; i <= 1; i++) for (var j = -1; j <= 1; j++) {
var L = grid[(gx + i) + "," + (gy + j)]; if (!L) continue;
for (var q = 0; q < L.length; q++) if (Math.hypot(L[q][0] - x, L[q][1] - y) < (rr + L[q][2]) * 0.86) return false;
}
return true;
}
function ok(x, y, rr) {
if (G.sdOut(x, y) > -(rr + 0.25) || G.sdAp(x, y) < rr + 0.35) return false;
for (var w = 0; w < G.windows.length; w++) if (G.windows[w].sd(x, y) < rr + 0.6) return false;
return (!keep || keep(x, y)) && free(x, y, rr);
}
function put(x, y, rr) { var kk = Math.floor(x / cell) + "," + Math.floor(y / cell); (grid[kk] = grid[kk] || []).push([x, y, rr]); out.push({ x: x, y: y, r: rr }); }
var d;
if (big) {
var rnd = seeded(29);
big.forEach(function (b) {
for (var t = 0; t < b[1]; t++) { var bx = -27 + rnd() * 54, by = -29 + rnd() * 58, br = b[0] * (0.94 + rnd() * 0.12); if (ok(bx, by, br)) put(bx, by, br); }
});
}
for (d = r + 0.4; d < 22; d += p * 0.88) {
walk(trace(function (x, y) { return G.sdAp(x, y) - d; }, G.ap[0], G.ap[1], 240, 45), p).forEach(function (pt) {
if (G.sdAp(pt.x, pt.y) > -G.sdOut(pt.x, pt.y) + 0.2) return;
if (ok(pt.x, pt.y, r)) put(pt.x, pt.y, r);
});
}
for (d = r + 0.25; d < 22; d += p * 0.88) {
walk(trace(function (x, y) { return G.sdOut(x, y) + d; }, 0, 0, 260, 45), p).forEach(function (pt) { if (ok(pt.x, pt.y, r)) put(pt.x, pt.y, r); });
}
[r, r * 0.75, r * 0.55].forEach(function (rr) {
for (var gy = -32; gy <= 32; gy += 0.2) for (var gx = -32; gx <= 32; gx += 0.2) if (ok(gx, gy, rr)) put(gx, gy, rr);
});
return out;
}
var _spikeGeo = null;
function spikeGeo() {
if (_spikeGeo) return _spikeGeo;
var pts = [new THREE.Vector2(0.001, 5.6), new THREE.Vector2(0.16, 5.5), new THREE.Vector2(0.32, 5.25), new THREE.Vector2(0.62, 4.1), new THREE.Vector2(1.0, 2.2), new THREE.Vector2(1.28, 0.6), new THREE.Vector2(1.38, -0.1), new THREE.Vector2(1.4, -0.6), new THREE.Vector2(0.001, -0.6)];
_spikeGeo = new THREE.LatheGeometry(pts, 18); _spikeGeo.computeVertexNormals();
return _spikeGeo;
}
function placeSpike(group, mat, x, y, z, dir, scale) {
var m = new THREE.Mesh(spikeGeo(), mat); m.position.set(x, y, z); m.quaternion.setFromUnitVectors(_y, dir.clone().normalize());
if (scale) m.scale.setScalar(scale); group.add(m); return m;
}
function iceRope(group, mat, poly, G, opt, stones) {
var pts = poly.map(function (p) { return new THREE.Vector3(p[0], p[1], 0); }), closed = !opt.open;
var curve = new THREE.CatmullRomCurve3(pts, closed, "centripetal"), L = curve.getLength();
var N = Math.max(240, Math.round(L * 5)), k, i;
var R = opt.R, rs = opt.rs, twists = Math.round(L / opt.pitch), nStr = opt.n || 2;
for (k = 0; k < nStr; k++) {
var sp = [], fr = [];
for (i = 0; i < (closed ? N : N + 1); i++) {
var s = i / N, P = curve.getPointAt(s), T = curve.getTangentAt(s), side = new THREE.Vector3(T.y, -T.x, 0).normalize();
var ph = Math.PI * 2 * twists * s + k * Math.PI * 2 / nStr, base = (opt.z ? opt.z(P.x, P.y) : prof(G, P.x, P.y)) + rs * 0.55 + R * 0.35;
var Q = new THREE.Vector3(P.x + side.x * Math.cos(ph) * R, P.y + side.y * Math.cos(ph) * R, base + Math.sin(ph) * R * 0.75);
sp.push(Q); fr.push({ Q: Q, side: side, T: T });
}
var strand = new THREE.CatmullRomCurve3(sp, closed);
group.add(new THREE.Mesh(new THREE.TubeGeometry(strand, N, rs, 14, closed), mat));
if (!closed) [0, 1].forEach(function (e) {
var cap = new THREE.Mesh(SPH(), mat); cap.scale.setScalar(rs); cap.position.copy(strand.getPointAt(e)); group.add(cap);
});
if (!stones) continue;
var SL = strand.getLength(), nAlong = Math.round(SL / (opt.sr * 2.05)), rows = opt.rows || [-0.95, -0.32, 0.32, 0.95];
for (i = 0; i < nAlong; i++) {
var u = (i + (k % 2) * 0.5) / nAlong; if (u >= 1) u = closed ? u - 1 : 0.999;
var Ps = strand.getPointAt(u), Ts = strand.getTangentAt(u);
var up = new THREE.Vector3(0, 0, 1), sd = new THREE.Vector3().crossVectors(Ts, up).normalize(), nUp = new THREE.Vector3().crossVectors(sd, Ts).normalize();
rows.forEach(function (a, ri) {
var aa = a + ((i % 2) ? 0.16 : -0.16) * (ri % 2 ? 1 : -1);
var n = nUp.clone().multiplyScalar(Math.cos(aa)).addScaledVector(sd, Math.sin(aa));
if (n.z < -0.2) return;
stoneAt(stones, Ps.x + n.x * (rs + 0.06), Ps.y + n.y * (rs + 0.06), Ps.z + n.z * (rs + 0.06), n.x, n.y, n.z, opt.sr * (ri === 0 || ri === rows.length - 1 ? 0.85 : 1), opt.scol);
});
}
}
return curve;
}
var FLAME_PATHS = [
{ p: [[-29.5, -7.9], [-22.8, 1.7], [-17.6, 10.9], [-6.8, 17.9], [4.3, 19.7], [13.6, 22.7], [17.8, 26.5]], w: 6.6, tipA: true, tipB: true },
{ p: [[16.6, 6.3], [21.2, 9.5], [24.6, 12.6], [28.4, 16.5]], w: 6.0, tipA: false, tipB: true },
{ p: [[9.6, -23.9], [13.0, -20.2], [17.8, -16.2], [24.2, -10.1], [30.4, -2.1]], w: 6.6, tipA: false, tipB: true },
{ p: [[-27.0, -26.7], [-22.2, -22.9], [-16.6, -19.2], [-13.6, -17.9]], w: 6.2, tipA: true, tipB: false }
];
function crPoly(P) {
var out = [], i, k;
for (i = 0; i < P.length - 1; i++) {
var p0 = P[Math.max(0, i - 1)], p1 = P[i], p2 = P[i + 1], p3 = P[Math.min(P.length - 1, i + 2)];
for (k = 0; k < 20; k++) {
var t = k / 20, t2 = t * t, t3 = t2 * t;
out.push([0.5 * (2 * p1[0] + (-p0[0] + p2[0]) * t + (2 * p0[0] - 5 * p1[0] + 4 * p2[0] - p3[0]) * t2 + (-p0[0] + 3 * p1[0] - 3 * p2[0] + p3[0]) * t3),
0.5 * (2 * p1[1] + (-p0[1] + p2[1]) * t + (2 * p0[1] - 5 * p1[1] + 4 * p2[1] - p3[1]) * t2 + (-p0[1] + 3 * p1[1] - 3 * p2[1] + p3[1]) * t3)]);
}
}
out.push(P[P.length - 1]);
return out;
}
function flameStripes(G) {
var segs = [], w0 = G.windows[0];
FLAME_PATHS.forEach(function (F, si) {
var dense = crPoly(F.p), L = [0], i;
for (i = 1; i < dense.length; i++) L.push(L[i - 1] + Math.hypot(dense[i][0] - dense[i - 1][0], dense[i][1] - dense[i - 1][1]));
var total = L[L.length - 1], pts = [], j = 0;
for (var d = 0; d <= total + 1e-6; d += 0.45) {
while (j < L.length - 2 && L[j + 1] < d) j++;
var f0 = (d - L[j]) / ((L[j + 1] - L[j]) || 1), x = dense[j][0] + (dense[j + 1][0] - dense[j][0]) * f0, y = dense[j][1] + (dense[j + 1][1] - dense[j][1]) * f0;
var ea = d, eb = total - d;
var fa = F.tipA ? Math.pow(Math.min(1, ea / 8.5), 0.85) : 0.62 + 0.38 * Math.min(1, ea / 2.2);
var fb = F.tipB ? Math.pow(Math.min(1, eb / 8.5), 0.85) : 0.62 + 0.38 * Math.min(1, eb / 2.2);
var f = Math.min(fa, fb), w = F.w * f * (0.84 + 0.16 * Math.abs(Math.cos(d * 0.55 + si))) + 0.2;
var need = w / 2 + 0.5 - G.sdAp(x, y); if (need > 0) { var rx = x - G.ap[0], ry = y - G.ap[1], rl = Math.hypot(rx, ry) || 1; x += rx / rl * need; y += ry / rl * need; }
if (w0.sd(x, y) < w / 2 + 0.6) continue;
pts.push({ x: x, y: y, w: w, u: 1 - f });
}
if (pts.length > 6) segs.push(pts);
});
return segs;
}
function overZ(G, x, y) {
var d = G.sdOut(x, y);
if (d < -0.2) return prof(G, x, y);
return TOP - (G.edgeD != null ? G.edgeD : EDGE_D) * 0.55 - Math.max(0, d) * 0.12;
}
function flameMesh(G, path, mat, relief) {
var pos = [], idx = [], K = 9, i, k, n = path.length;
var skirt = [];
for (i = 0; i < n; i++) {
var p = path[i], q = path[Math.min(n - 1, i + 1)], o = path[Math.max(0, i - 1)];
var tx = q.x - o.x, ty = q.y - o.y, tl = Math.hypot(tx, ty) || 1, nx = -ty / tl, ny = tx / tl;
for (k = 0; k < K; k++) {
var t = k / (K - 1) * 2 - 1, x = p.x + nx * t * p.w / 2, y = p.y + ny * t * p.w / 2;
pos.push(x, y, overZ(G, x, y) + relief * Math.sqrt(Math.max(0, 1 - t * t)) * (1 - 0.35 * p.u) + 0.05);
}
p.nx = nx; p.ny = ny;
}
for (i = 0; i < n - 1; i++) for (k = 0; k < K - 1; k++) { var a = i * K + k; idx.push(a, a + K, a + 1, a + 1, a + K, a + K + 1); }
var base = pos.length / 3;
for (i = 0; i < n; i++) {
[0, K - 1].forEach(function (kk, si) {
var j = (i * K + kk) * 3; pos.push(pos[j], pos[j + 1], pos[j + 2] - relief - 1.2);
});
}
for (i = 0; i < n - 1; i++) {
var l0 = i * K, l1 = (i + 1) * K, r0 = i * K + K - 1, r1 = (i + 1) * K + K - 1, b0 = base + i * 2, b1 = base + (i + 1) * 2;
idx.push(l0, b0, l1, l1, b0, b1); idx.push(r0, r1, b0 + 1, r1, b1 + 1, b0 + 1);
}
var geo = new THREE.BufferGeometry();
geo.setAttribute("position", new THREE.Float32BufferAttribute(pos, 3)); geo.setIndex(idx); geo.computeVertexNormals();
var m = new THREE.Mesh(geo, mat); m.material.side = THREE.DoubleSide; return m;
}
function build() {
clearRoot(); _spikeGeo = null;
var D = designObj(), F = FINISH[state.finish] || FINISH.Silver, G = modelGeo(state.design);
var stones = [];
var hasCover = !state.bare, st = state.design;
var C = COLOURS[state.colour];
add(bezelGeo(G, G.caseOutline, CASE_TOP - CASE_BOT, CASE_TOP, false, true), resinMat, true);
if (!hasCover) add(coverGeo(G, TOP - 0.5, COVER_H), resinMat, true);
var fm = new THREE.MeshBasicMaterial({ map: faceTexture(C), color: 0xD8D8D8 });
faceMesh = new THREE.Mesh(faceGeo(G.apertureFace), fm); faceMesh.userData.ownsMat = true; faceMesh.position.z = FACE_Z; root.add(faceMesh);
var glass = new THREE.Mesh(faceGeo(G.apertureFace), glassMat); glass.position.z = FACE_Z + 1.1; glass.renderOrder = 2; root.add(glass);
var pushGeo = new THREE.CylinderGeometry(1.45, 1.55, 1.8, 24); pushGeo.rotateZ(Math.PI / 2);
G.buttons.forEach(function (b) {
var ex = edgeX(G.sdOut, b[1], b[0]), px = b[0] * (ex + 0.5 + bgv(G));
add(pushGeo, hasCover ? metalMat : buckleMat, true).position.set(px, b[1], TOP - 5.6);
var dome = add(SPH(), hasCover ? metalMat : buckleMat, true); dome.scale.set(0.75, 1.45, 1.45); dome.position.set(px + b[0] * 0.9, b[1], TOP - 5.6);
});
buildStrap(G, stones, false);
if (hasCover) {
add(coverGeo(G, TOP, COVER_H), metalMat, true);
var accentMat = F.acc ? accMat : metalMat;
var feat = new THREE.Group(); root.add(feat);
var onTop = function (x, y, r, col, lift) { var n = topN(G, x, y); stoneAt(stones, x, y, topZ(G, x, y) + (lift || 0), n.x, n.y, n.z, r, col); };
G.windows.forEach(function (w) {
var zc = prof(G, w.c[0], w.c[1]);
add(new THREE.ShapeGeometry(toShape(w.poly)), windowMat).position.z = zc - 1.6;
var pl = toShape(trace(function (x, y) { return w.sd(x, y) + 0.7; }, w.c[0], w.c[1], 48, 12));
var plate = add(new THREE.ExtrudeGeometry(pl, { depth: 0.9, bevelEnabled: true, bevelThickness: 0.35, bevelSize: 0.35, bevelSegments: 3 }), plateMat);
plate.position.z = zc - 1.5;
var ring = new THREE.Mesh(new THREE.TorusGeometry(1.35, 0.16, 8, 32, Math.PI * 1.6), plateInk); ring.rotation.z = 0.5;
ring.position.set(w.c[0], w.c[1], zc - 0.15); root.add(ring);
var fr = toShape(trace(function (x, y) { return w.sd(x, y) - 0.6; }, w.c[0], w.c[1], 64, 14)); fr.holes.push(toPath(w.poly));
add(new THREE.ExtrudeGeometry(fr, { depth: 0.3, bevelEnabled: true, bevelThickness: 0.15, bevelSize: 0.15, bevelSegments: 2 }), metalMat).position.z = zc - 0.1;
});
[[1, 21.6], [-1, 21.6], [1, -23.2], [-1, -23.2]].forEach(function (sw) {
var ex = edgeX(G.sdOut, sw[1], sw[0]), nx = sw[0], zc = TOP - COVER_H * 0.42;
var head = new THREE.Mesh(new THREE.CylinderGeometry(1.25, 1.35, 0.7, 24), metalMat); head.rotation.z = Math.PI / 2;
head.position.set(nx * (ex + bgv(G) * 0.9 + 0.25), sw[1], zc); feat.add(head);
var hole = new THREE.Mesh(new THREE.CylinderGeometry(0.42, 0.42, 0.3, 6), darkMat); hole.rotation.z = Math.PI / 2;
hole.position.set(nx * (ex + bgv(G) * 0.9 + 0.62), sw[1], zc); feat.add(hole);
});
var exclude = null, baseR = 0.5, big = null, liftK = 0;
var apRing = function (lo, hi) { return function (x, y) { var d = G.sdAp(x, y); return d < lo || d > hi; }; };
var flames = [];
if (st === "flame") {
baseR = 0.46;
flames = flameStripes(G);
exclude = function (x, y) {
for (var a = 0; a < flames.length; a++) for (var b = 0; b < flames[a].length; b++) {
var q = flames[a][b]; if (Math.hypot(x - q.x, y - q.y) < q.w / 2 + 0.3) return false;
}
return true;
};
}
if (st === "spike")   { baseR = 0.52; big = [[0.78, 500], [0.66, 900]]; }
if (st === "thorn")   { baseR = 0.55; exclude = apRing(1.4, 6.6); }
if (st === "rope")    { baseR = 0.42; }
if (st === "cluster") { baseR = 0.6; exclude = apRing(-1, 3.0); }
var keep = function (x, y) { return !exclude || exclude(x, y); };
paveRows(G, baseR, keep, big).forEach(function (s) { onTop(s.x, s.y, s.r, null, liftK * Math.max(0, s.r - baseR)); });
walk(G.outline, baseR * 1.9).forEach(function (pt, i) {
var zE = prof(G, pt.x - pt.nx * 0.02, pt.y - pt.ny * 0.02), H = zE - (TOP - COVER_H), dt = baseR * 1.8 / H;
for (var t = 0.06 + ((i % 2) ? dt / 2 : 0); t < 0.93; t += dt) {
var dl = bulge(t, G), up = bulgeD(t, G) / H, nl = Math.hypot(1, up);
stoneAt(stones, pt.x + pt.nx * (dl + 0.02), pt.y + pt.ny * (dl + 0.02), zE - t * H, pt.nx / nl, pt.ny / nl, up / nl, baseR * (st === "cluster" ? 1.15 : 0.95), null);
}
});
walk(G.aperture, 0.76).forEach(function (pt, i) {
stoneAt(stones, pt.x - pt.nx * 0.02, pt.y - pt.ny * 0.02, TOP - SLOPE - 0.5, -pt.nx, -pt.ny, 0.15, 0.42, null);
stoneAt(stones, pt.x - pt.nx * 0.02, pt.y - pt.ny * 0.02, TOP - SLOPE - 1.3 - ((i % 2) ? 0.3 : 0), -pt.nx, -pt.ny, 0.05, 0.42, null);
});
var lip = toShape(trace(function (x, y) { return G.sdAp(x, y) - 0.55; }, G.ap[0], G.ap[1], 200, 30)); lip.holes.push(toPath(G.aperture));
add(new THREE.ExtrudeGeometry(lip, { depth: 0.25, bevelEnabled: true, bevelThickness: 0.15, bevelSize: 0.12, bevelSegments: 2 }), metalMat).position.z = TOP - SLOPE - 0.35;
if (st === "flame") {
var fcol = F.stone != null ? F.stone : 0xC0247A;
flames.forEach(function (path, fi) {
feat.add(flameMesh(G, path, metalMat, 1.25));
for (var i = 0; i < path.length; i++) {
var p = path[i]; if (p.w < 0.9) continue;
var nrow = Math.max(1, Math.floor((p.w - 0.5) / 1.02)), along = (i % 2) ? 0.5 : 0;
for (var q = 0; q < nrow; q++) {
var off = (q - (nrow - 1) / 2) * 1.02 + (nrow > 2 ? (along - 0.25) * 0.3 : 0), tt = off / (p.w / 2);
if (Math.abs(tt) > 0.92) continue;
var x = p.x + p.nx * off, y = p.y + p.ny * off, z = overZ(G, x, y) + 1.25 * Math.sqrt(Math.max(0, 1 - tt * tt)) * (1 - 0.35 * p.u) + 0.05;
var n = new THREE.Vector3(p.nx * tt * 0.7, p.ny * tt * 0.7, 1).normalize();
var colour = Math.abs(tt) < 0.62 ? fcol : null;
stoneAt(stones, x, y, z, n.x, n.y, n.z, 0.48, colour);
}
}
(path.length > 40 ? [0.3, 0.72] : [0.5]).forEach(function (u0, di) {
var k0 = Math.round(u0 * (path.length - 1)), P0 = path[k0], P1 = path[Math.min(path.length - 1, k0 + 1)];
var side = ((di + fi) % 2) ? 1 : -1, ox = P0.x + P0.nx * side * (P0.w / 2 + 0.7), oy = P0.y + P0.ny * side * (P0.w / 2 + 0.7);
var tdx = P1.x - P0.x, tdy = P1.y - P0.y, tl = Math.hypot(tdx, tdy) || 1;
var dir = new THREE.Vector3(tdx / tl * 0.55 + P0.nx * side * 0.35, tdy / tl * 0.55 + P0.ny * side * 0.35, 0.75).normalize();
var z0 = overZ(G, ox, oy);
var bead = new THREE.Mesh(SPH(), clawMat); bead.scale.set(1.05, 1.05, 0.95); bead.position.set(ox, oy, z0 + 0.7); feat.add(bead);
var tip = new THREE.Mesh(new THREE.ConeGeometry(0.98, 2.6, 16), clawMat);
tip.position.set(ox + dir.x * 1.5, oy + dir.y * 1.5, z0 + 0.7 + dir.z * 1.5); tip.quaternion.setFromUnitVectors(_y, dir); feat.add(tip);
});
});
}
if (st === "spike") {
walk(G.outline, 4.9).forEach(function (pt, i) {
if (pt.y < -24.5 && Math.abs(pt.x) < 9) return;
var dir = new THREE.Vector3(pt.nx, pt.ny, 0.12 + (i % 2) * 0.1);
placeSpike(feat, accentMat, pt.x - pt.nx * 0.2, pt.y - pt.ny * 0.2, TOP - 3.2, dir, 1.0);
});
walk(trace(function (x, y) { return G.sdOut(x, y) + 5.8; }, 0, 0, 220, 40), 7.2).forEach(function (pt) {
if (G.windows[0].sd(pt.x, pt.y) < 2.2) return;
var z = prof(G, pt.x, pt.y), dir = new THREE.Vector3(pt.nx * 0.85, pt.ny * 0.85, 0.75);
placeSpike(feat, accentMat, pt.x, pt.y, z - 0.2, dir, 0.82);
});
}
if (st === "thorn") {
var vPath = trace(function (x, y) { return G.sdAp(x, y) - 3.9; }, G.ap[0], G.ap[1], 160, 30);
var vc = iceRope(feat, accentMat, vPath, G, { R: 1.35, rs: 1.25, pitch: 15, n: 2, sr: 0.6, rows: [-0.8, 0, 0.8], scol: null }, stones);
for (var ti = 0; ti < 24; ti++) {
var s0 = (ti + 0.3) / 24, P = vc.getPointAt(s0), T = vc.getTangentAt(s0), side = new THREE.Vector3(T.y, -T.x, 0).normalize();
var out = (ti % 2) ? 1 : -1;
var dir = new THREE.Vector3(side.x * out * 0.7 + T.x * 0.45, side.y * out * 0.7 + T.y * 0.45, 0.55).normalize();
var z0 = prof(G, P.x, P.y) + 1.6;
var th = new THREE.Mesh(new THREE.ConeGeometry(0.62, 4.2, 14), accentMat);
th.position.set(P.x + side.x * out * 1.3 + dir.x * 1.6, P.y + side.y * out * 1.3 + dir.y * 1.6, z0 + dir.z * 1.6); th.quaternion.setFromUnitVectors(_y, dir); feat.add(th);
}
}
if (st === "rope") {
var RO = { R: 1.15, rs: 1.95, pitch: 7.4, n: 2, sr: 0.5, rows: [-1.25, -0.62, 0, 0.62, 1.25] };
iceRope(feat, metalMat, trace(function (x, y) { return G.sdAp(x, y) - 3.1; }, G.ap[0], G.ap[1], 200, 30), G, RO, stones);
var edge = [];
for (var ea = -64; ea <= 244; ea += 2) {
var ec = Math.cos(ea * Math.PI / 180), es = Math.sin(ea * Math.PI / 180), er = rayHit(function (x, y) { return G.sdOut(x, y) + 3.0; }, 0, 0, ec, es, 45);
edge.push([ec * er, es * er]);
}
iceRope(feat, metalMat, edge, G, { R: 1.15, rs: 1.95, pitch: 7.4, n: 2, sr: 0.5, rows: RO.rows, open: true }, stones);
var loop = [[-8.4, -18.2], [-10.0, -19.8], [-10.3, -22.4], [-8.8, -24.6], [-4.8, -25.6], [0, -25.8], [4.8, -25.6], [8.8, -24.6], [10.3, -22.4], [10.0, -19.8], [8.4, -18.2]];
iceRope(feat, metalMat, loop, G, { R: 0.8, rs: 1.35, pitch: 5.6, n: 2, sr: 0.45, rows: [-1.0, -0.33, 0.33, 1.0], open: true }, stones);
}
if (st === "cluster") {
walk(trace(function (x, y) { return G.sdAp(x, y) - 1.75; }, G.ap[0], G.ap[1], 220, 30), 2.2).forEach(function (pt) { onTop(pt.x, pt.y, 1.02, null, 0.25); });
}
}
if (stones.length) { var rec = makeInstanced(stoneGeo(), stones); root.add(rec.mesh); anim.stones.push(rec); }
root.updateMatrixWorld(true);
var box = new THREE.Box3();
root.traverse(function (o) { if (o.isMesh && o.userData.isWatch) box.expandByObject(o); });
var c = box.getCenter(new THREE.Vector3());
root.position.set(-c.x, -c.y, -c.z * 0.35);
fitSpan = box.getSize(new THREE.Vector3());
frameCamera();
anim.setStart = clock.w; anim.settling = stones.length > 0;
paintReadout(stones.length);
}
function lin(h) { return new THREE.Color(h).convertSRGBToLinear(); }
function retintWatch() {
var C = COLOURS[state.colour];
resinMat.color.copy(lin(C.band));
plateMat.color.copy(lin(C.plate));
plateInk.color.copy(lin(state.colour === "black" ? 0xB8C0C8 : state.colour === "white" ? 0x2A2E33 : 0x5A140E));
windowMat.color.copy(lin(C.band)).multiplyScalar(0.4);
if (faceMesh) {
var old = faceMesh.material.map;
faceMesh.material.map = faceTexture(C);
faceMesh.material.needsUpdate = true; if (old) old.dispose();
}
}
function applyFinish(instant) {
var F = FINISH[state.finish] || FINISH.Silver, B = METAL[F.base], A = METAL[F.acc || F.base];
if (instant) { metalMat.color.setHex(B.col); metalMat.roughness = B.rough; accMat.color.setHex(A.col); accMat.roughness = A.rough; anim.metalTo = null; }
else anim.metalTo = { c: new THREE.Color(B.col), r: B.rough, a: new THREE.Color(A.col) };
}
var fitSpan = null;
function frameCamera() {
if (!fitSpan) return;
var half = Math.tan((camera.fov / 2) * Math.PI / 180);
var byH = (Math.min(fitSpan.y, 96) * 1.05 + 10) / (2 * half);
var byW = (fitSpan.x * 1.3 + 8) / (2 * half * Math.max(0.5, camera.aspect));
cam.tDist = Math.max(50, Math.max(byH, byW) * 1.12);
}
function easeBack(t) { var c1 = 1.70158, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); }
function stepSetting() {
if (!anim.settling) return;
var el = clock.w - anim.setStart, done = true, k;
anim.stones.forEach(function (rec) {
var n = rec.pos.length, i;
for (i = 0; i < n; i++) {
var t = (el - rec.delay[i] * anim.setDur) / 0.38;
if (t < 0) { done = false; continue; }
if (t >= 1) k = 1; else { k = easeBack(t); done = false; }
_sc.copy(rec.scl[i]).multiplyScalar(Math.max(0.0001, k));
_wp.copy(rec.pos[i]);
if (t < 1) { _n.set(0, 1, 0).applyQuaternion(rec.quat[i]); _wp.addScaledVector(_n, (1 - t) * 1.6); }
_m.compose(_wp, rec.quat[i], _sc);
rec.mesh.setMatrixAt(i, _m);
}
rec.mesh.instanceMatrix.needsUpdate = true;
});
if (done) anim.settling = false;
}
var TINTS = [[1, 1, 1], [1, 1, 1], [0.6, 0.78, 1], [1, 0.62, 0.62], [1, 0.9, 0.5], [0.62, 1, 0.72], [0.9, 0.62, 1]];
function stepFire(dt) {
if (!anim.stones.length || anim.settling) return;
var total = 0; anim.stones.forEach(function (r) { total += r.pos.length; });
var want = total / 22, i, spawn = (want / 0.55) * dt;
while (spawn > 0) {
if (Math.random() < spawn) {
var rec = anim.stones[Math.floor(Math.random() * anim.stones.length)];
anim.flashes.push({ rec: rec, i: Math.floor(Math.random() * rec.pos.length), t0: clock.w, dur: 0.35 + Math.random() * 0.5, tint: TINTS[Math.floor(Math.random() * TINTS.length)], amp: 2.5 + Math.random() * 4.5 });
}
spawn -= 1;
}
var touched = new Set();
for (i = anim.flashes.length - 1; i >= 0; i--) {
var f = anim.flashes[i], life = (clock.w - f.t0) / f.dur, b = f.rec.base[f.i];
if (life >= 1) { f.rec.mesh.setColorAt(f.i, b); touched.add(f.rec.mesh); anim.flashes.splice(i, 1); continue; }
var s = Math.sin(life * Math.PI); s = s * s * f.amp;
_flash.setRGB(b.r + s * f.tint[0], b.g + s * f.tint[1], b.b + s * f.tint[2]);
f.rec.mesh.setColorAt(f.i, _flash); touched.add(f.rec.mesh);
}
touched.forEach(function (m) { if (m.instanceColor) m.instanceColor.needsUpdate = true; });
}
function stepMetal() {
if (!anim.metalTo) return;
var M = anim.metalTo;
metalMat.color.lerp(M.c, 0.085); accMat.color.lerp(M.a, 0.085);
metalMat.roughness += (M.r - metalMat.roughness) * 0.085;
var d = Math.abs(metalMat.color.r - M.c.r) + Math.abs(metalMat.color.g - M.c.g) + Math.abs(metalMat.color.b - M.c.b)
+ Math.abs(accMat.color.r - M.a.r) + Math.abs(accMat.color.g - M.a.g) + Math.abs(accMat.color.b - M.a.b);
if (d < 0.006) { metalMat.color.copy(M.c); accMat.color.copy(M.a); metalMat.roughness = M.r; anim.metalTo = null; }
}
function tick(now) {
requestAnimationFrame(tick);
if (!resize()) return;
var ms = now || 0, dt = Math.min(0.05, (ms - clock.last) / 1000 || 0.016);
clock.last = ms; clock.t += dt; clock.w = ms / 1000;
if (spin && !dragging) { swayT += dt; cam.tAz = Math.sin(swayT * 0.42) * 0.7; cam.tEl = 0.34 + Math.sin(swayT * 0.3) * 0.16; }
cam.az += (cam.tAz - cam.az) * 0.12; cam.el += (cam.tEl - cam.el) * 0.12;
cam.dist += (cam.tDist - cam.dist) * (anim.introDone ? 0.08 : 0.035);
if (!anim.introDone && Math.abs(cam.dist - cam.tDist) < 0.6) anim.introDone = true;
root.rotation.x = Math.sin(clock.t * 0.55) * 0.04; root.rotation.z = Math.sin(clock.t * 0.37) * 0.02;
keyLight.position.set(26 + Math.sin(clock.t * 0.42) * 24, 42 + Math.cos(clock.t * 0.31) * 9, 58 + Math.sin(clock.t * 0.27) * 14);
rimLight.position.set(-44 + Math.cos(clock.t * 0.23) * 18, 14, -36 + Math.sin(clock.t * 0.29) * 16);
stepSetting(); stepFire(dt); stepMetal();
var ce = Math.cos(cam.el), se = Math.sin(cam.el);
camera.position.set(Math.sin(cam.az) * ce * cam.dist, se * cam.dist, Math.cos(cam.az) * ce * cam.dist);
camera.lookAt(0, 0, 0);
renderer.render(scene, camera);
}
cvs.addEventListener("pointerdown", function (e) {
dragging = true; spin = false; $G("btnSpin").setAttribute("aria-pressed", "false"); lastX = e.clientX; lastY = e.clientY;
cvs.classList.add("drag");
if (cvs.setPointerCapture) { try { cvs.setPointerCapture(e.pointerId); } catch (x) {} }
});
cvs.addEventListener("pointermove", function (e) {
if (!dragging) return;
cam.tAz -= (e.clientX - lastX) * 0.0085;
cam.tEl = Math.max(-1.2, Math.min(1.35, cam.tEl + (e.clientY - lastY) * 0.0065));
lastX = e.clientX; lastY = e.clientY;
});
["pointerup", "pointercancel", "pointerleave"].forEach(function (k) { cvs.addEventListener(k, function () { dragging = false; cvs.classList.remove("drag"); }); });
cvs.addEventListener("wheel", function (e) { e.preventDefault(); userZoomed = true; cam.tDist = Math.max(40, Math.min(320, cam.tDist + e.deltaY * 0.1)); }, { passive: false });
function btn(label, meta, pressed, onClick, swatch, img) {
var b = document.createElement("button");
b.className = "s-opt" + (img ? " g-card" : ""); b.type = "button"; b.setAttribute("aria-pressed", pressed ? "true" : "false");
if (img) { var im = document.createElement("img"); im.className = "g-th"; im.alt = ""; im.loading = "lazy"; im.src = img; b.appendChild(im); }
if (swatch) { var s = document.createElement("span"); s.className = "s-sw"; s.style.background = swatch; b.appendChild(s); }
var n = document.createElement("span"); n.className = "s-nm"; n.textContent = label; b.appendChild(n);
if (meta) { var m = document.createElement("span"); m.className = "s-meta"; m.textContent = meta; b.appendChild(m); }
b.addEventListener("click", onClick);
return b;
}
function fromPrice(D) { var lo = Infinity; Object.keys(D.f).forEach(function (k) { lo = Math.min(lo, D.f[k][1]); }); return lo; }
function pickDesign(key) {
state.design = key;
var fs = Object.keys(designObj().f);
if (fs.indexOf(state.finish) < 0) state.finish = fs[0];
applyFinish(true);
}
var THUMBS = window.FF_G_THUMBS || {};
function renderOptions() {
var D = designObj();
var oC = $G("optColour"); oC.textContent = "";
Object.keys(COLOURS).forEach(function (k) {
oC.appendChild(btn(COLOURS[k].name, "", state.colour === k, function () {
if (state.colour === k) return;
state.colour = k; retintWatch(); renderOptions();
}, COLOURS[k].sw));
});
var cb = $G("colourBlurb");
if (cb) cb.textContent = state.colour === "red" ? "Red band and case with the red face." : state.colour === "white" ? "White band and case with the black face." : "Black band and case with the black face.";
var oG = $G("optDesign"); oG.textContent = "";
Object.keys(DESIGNS).forEach(function (k) {
var d = DESIGNS[k];
oG.appendChild(btn(d.name, money(fromPrice(d)), state.design === k, function () {
if (state.design === k) return;
pickDesign(k); build(); renderOptions();
}, null, THUMBS[d.code]));
});
$G("designBlurb").textContent = D.blurb;
var oF = $G("optFinish"); oF.textContent = "";
Object.keys(D.f).forEach(function (k) {
oF.appendChild(btn(FINISH[k].label, "", state.finish === k, function () {
if (state.finish === k) return;
var before = FINISH[state.finish], after = FINISH[k];
state.finish = k;
if (before.stone !== after.stone || !!before.acc !== !!after.acc) { applyFinish(true); build(); }
else applyFinish(false);
renderOptions();
}, FINISH[k].sw));
});
var fb = $G("finishBlurb");
if (fb) fb.textContent = state.design === "flame" ? "The colour of the flame stones. The cover itself is white gold." : "Brass plated in the metal you pick. The stones stay white.";
var sc = $G("specCover"); if (sc) sc.textContent = D.name + " (" + D.code + ")";
paintQuote();
}
function paintQuote() {
var D = designObj(), fv = D.f[state.finish];
$G("qLabel").textContent = COLOURS[state.colour].name + " DW-6900 · " + D.name + " · " + FINISH[state.finish].label;
$G("qPrice").textContent = money(fv[1]);
$G("qNote").textContent = "Watch and iced cover together. 6–8 weeks from the day you order, then shipping.";
paintCta();
}
function paintCta() {
var ag = $G("agree"), a = $G("cta"); if (!ag || !a) return;
var ok = ag.checked, u = ok ? checkoutURL() : "";
if (u) { a.href = u; a.setAttribute("aria-disabled", "false"); } else { a.href = "#"; a.setAttribute("aria-disabled", "true"); }
var n = $G("ctaNote"); if (n) n.textContent = ok ? "Checkout opens with this set in the cart." : "Tick the box to unlock checkout. Your build rides along on the order.";
}
var lastStoneCt = 0;
function paintReadout(stones) {
if (stones != null) lastStoneCt = stones;
var ro = $G("readout");
ro.innerHTML = "<b>" + designObj().name + "</b> · " + COLOURS[state.colour].name + " · " + FINISH[state.finish].label + "<br><b>" + lastStoneCt.toLocaleString("en-US") + "</b> stones set";
}
$G("btnSpin").addEventListener("click", function () { spin = !spin; swayT = 0; this.setAttribute("aria-pressed", spin ? "true" : "false"); });
$G("btnReset").addEventListener("click", function () { cam.tAz = 0; cam.tEl = 0.34; swayT = 0; userZoomed = false; anim.introDone = false; build(); cam.dist = cam.tDist + 60; });
$G("btnBare").addEventListener("click", function () { state.bare = !state.bare; this.setAttribute("aria-pressed", state.bare ? "true" : "false"); build(); });
(function () {
var q = new URLSearchParams(location.search), toks = (location.hash || "").replace("#", "").toLowerCase().split(".");
if (COLOURS[q.get("c")]) state.colour = q.get("c");
if (DESIGNS[q.get("d")]) state.design = q.get("d");
toks.forEach(function (h) {
if (COLOURS[h]) state.colour = h;
if (DESIGNS[h]) state.design = h;
if (h === "bare") state.bare = true;
});
var fs = Object.keys(designObj().f), fi = parseInt(q.get("f"), 10);
if (fi >= 0 && fs[fi]) state.finish = fs[fi];
if (fs.indexOf(state.finish) < 0) state.finish = fs[0];
var ol = $G("termsList");
if (ol) TERMS.forEach(function (t) { var li = document.createElement("li"); li.textContent = t; ol.appendChild(li); });
var ag = $G("agree"); if (ag) ag.addEventListener("change", paintCta);
var ct = $G("cta"); if (ct) ct.addEventListener("click", function (e) { if (this.getAttribute("aria-disabled") === "true") { e.preventDefault(); var g = $G("agree"); if (g) g.focus(); } });
if (state.bare) $G("btnBare").setAttribute("aria-pressed", "true");
})();
init();
retintWatch();
applyFinish(true);
renderOptions();
build();
requestAnimationFrame(tick);
})();
